"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_redux_1 = require("react-redux");
const sliceReview_1 = require("../../../slice/sliceReview");
const store_1 = require("../../../store");
const constants_1 = require("../../../slice/sliceReview/constants");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const sliceTemplate_1 = require("../../../slice/sliceTemplate");
const constants_2 = require("../../../slice/sliceTemplate/constants");
const selectors_1 = __importDefault(require("../../../slice/selectors"));
const SaveAsTemplate = () => {
    const { savingMethod, historyPhases, allowNext } = (0, react_redux_1.useSelector)(selectors_1.default);
    const OPTIONS = [
        {
            type: constants_1.SAVE_AS_TEMPLATE_OPTION.new,
            label: 'Save as New Template',
        },
        {
            type: constants_1.SAVE_AS_TEMPLATE_OPTION.existing,
            label: 'Update Existing Template',
        },
    ];
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    (0, react_1.useEffect)(() => {
        if (savingMethod) {
            dispatch((0, sliceReview_1.enableNextBtn)());
        }
    }, [savingMethod, historyPhases]);
    const handleChangeSavingMethod = (value) => {
        dispatch((0, sliceTemplate_1.selectSavingMethod)(value));
        if (value === constants_1.SAVE_AS_TEMPLATE_OPTION.new) {
            dispatch((0, sliceReview_1.openTemplateModal)(constants_2.SAVING_METHOD.saveAsNew));
        }
        if (value === constants_1.SAVE_AS_TEMPLATE_OPTION.existing) {
            dispatch((0, sliceReview_1.openTemplateModal)(constants_2.SAVING_METHOD.updateExisting));
        }
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-option__root'] },
        "Choose how you want to save your template:",
        react_1.default.createElement("div", { className: styles_modules_less_1.default['modal-option__list'] }, OPTIONS.map((option) => {
            return (react_1.default.createElement("div", { key: option.type, className: (0, clsx_1.default)(styles_modules_less_1.default['modal-option__item'], savingMethod === option.type &&
                    styles_modules_less_1.default['modal-option__item--selected']), onClick: () => {
                    handleChangeSavingMethod(option.type);
                } },
                react_1.default.createElement("div", { className: styles_modules_less_1.default['option-item__content'] },
                    react_1.default.createElement("i", { className: (0, clsx_1.default)(option.type === constants_1.SAVE_AS_TEMPLATE_OPTION.new
                            ? 'fal fa-file-alt'
                            : 'fal fa-file-plus', styles_modules_less_1.default['option-item__icon']) }),
                    react_1.default.createElement("h4", { className: styles_modules_less_1.default['option-item__label'] }, option.label))));
        }))));
};
exports.default = SaveAsTemplate;
